import './App.css';
// import Login from './components/login/login'
import 'primeicons/primeicons.css';
import { useState ,useEffect } from 'react';
import NavContext from './contexts/NavContext';
import RouterComponent from './Router';
import { CartProvider } from './contexts/CartContext';

import NotificationHandler from './components/custom/notification-handler';
const App = () => {
  const [nav, setNav] = useState('');
  const value = { nav, setNav };

  useEffect(() => {
    const expireTime = localStorage.getItem('tokenExpireAt');
    if (expireTime) {
        const timeout = Number(expireTime) - Date.now();
        if (timeout > 0) {
            setTimeout(() => {
                localStorage.removeItem('userInfo');
                localStorage.removeItem('tokenExpireAt');
                window.location.href = '/';
            }, timeout);
        } else {
            // اگر از قبل منقضی شده بود
            localStorage.removeItem('userInfo');
            localStorage.removeItem('tokenExpireAt');
            window.location.href = '/';
        }
    }
}, []);

  return (
    <NavContext.Provider value={value}>
      <CartProvider>
      <NotificationHandler />
      <RouterComponent />
      </CartProvider>
    </NavContext.Provider>
  );
}

export default App;
